import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import MenuItem from './MenuItem.js';

/**
 * Toast component
 */
export default class MainMenu extends withBreakpointObserver(Base) {
  submenuOpen = false;
  isOpen = false;

  /**
   * Component Configuration
   */
  static config = {
    name: 'MainMenu',
    refs: ['close[]'],
    components: {
      MenuItem,
    },
    emits: ['change'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m l xl',
      },
    },
  };

  /**
   *
   */
  toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeMenu();
    }
  }

  /**
   *
   */
  openMenu() {
    this.isOpen = true;
    this.$emit('change');
    document.documentElement.classList.add('is-menu-open');
  }

  /**
   *
   */
  closeMenu() {
    this.isOpen = false;
    if (this.submenuOpen) {
      this.closeAllSubmenus();
    }

    this.$emit('change');

    document.documentElement.classList.remove('is-menu-open');
  }

  /**
   *
   */
  onCloseclick() {
    this.closeMenu();
  }

  /**
   * Close all submenu when closing Menu
   * @returns {void}
   */
  closeAllSubmenus() {
    this.$children.MenuItem.filter((element) => element.open).forEach((element) => {
      element.closeSubmenu();
    });
  }
}
